"use client";
import React from "react";
import { m } from "motion/react";
import Image from "next/image";

export const BrandingVisual = () => {
    return (
        <div className="absolute inset-0 flex items-center justify-center bg-transparent group overflow-hidden">
            {/* ─── THE EVENT HORIZON (Background Distortion) ─── */}
            <div className="absolute inset-0 bg-gradient-to-br from-neutral-900/50 to-black/80 opacity-60 z-0" />

            {/* ─── ACCRETION DISK (Orbiting Matter) ─── */}
            {/* Outer Debris Ring - Heavy, slow rotation */}
            {/* <m.div
                className="absolute w-[280px] h-[280px] rounded-full border border-midas-yellow-500/10 border-dashed"
                animate={{ rotate: 360 }}
                transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
            /> */}
            <m.div
                className="absolute w-[220px] h-[220px] rounded-full border border-white/5"
                animate={{ rotate: -360 }}
                transition={{ duration: 45, repeat: Infinity, ease: "linear" }}
            />

            {/* Middle Active Ring - Transforming Matter */}
            <m.div
                className="absolute w-[160px] h-[160px] rounded-full border-[1px] border-b-midas-yellow-500/30 border-t-transparent border-l-transparent border-r-midas-yellow-500/30"
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            />

            {/* Inner High-Energy Ring - Fast */}
            <m.div
                className="absolute w-[100px] h-[100px] rounded-full border-[2px] border-midas-yellow-500/60 border-t-transparent blur-[1px]"
                animate={{ rotate: -360 }}
                transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
            />

            {/* ─── INCOMING MATTER (Particles being pulled in) ─── */}
            {[0, 1, 2, 3].map((i) => (
                <m.div
                    key={i}
                    className="absolute w-1 h-1 bg-white rounded-full shadow-[0_0_10px_white]"
                    initial={{ opacity: 0, scale: 0, x: 100, y: 100 }} // Start far
                    animate={{
                        opacity: [0, 1, 1, 0],
                        scale: [0.5, 1, 0], // Shrink as it hits singularity
                        x: [120 * Math.cos(i * 1.5), 0], // Spiral in X
                        y: [120 * Math.sin(i * 1.5), 0], // Spiral in Y
                    }}
                    transition={{
                        duration: 3 + i, // Staggered arrival
                        repeat: Infinity,
                        ease: "easeIn",
                        delay: i * 0.5,
                    }}
                />
            ))}

            {/* ─── THE SINGULARITY (Core) ─── */}
            <div className="relative z-10 flex items-center justify-center">
                {/* Core Glow - The Heart of Midas */}
                <m.div
                    className="absolute inset-0 rounded-full bg-midas-yellow-500 blur-[30px] opacity-20 pointer-events-none"
                    animate={{ opacity: [0.2, 0.4, 0.2], scale: [1, 1.2, 1] }}
                    transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
                />

                {/* 
                    THE MORPHING CONTAINER (Restored Logic)
                    - Replaces the static black/gold core.
                    - Keeps the "Folga" rotation for the inner logo.
                */}
                <m.div
                    className="relative flex items-center justify-center w-32 h-32 border-2 border-midas-yellow-500 shadow-[0_0_30px_rgba(234,179,8,0.3)] z-10"
                    style={{ borderRadius: "50%" }}
                    animate={{
                        borderRadius: ["50%", "20%", "50%"],
                        rotate: [0, 90, 180, 270, 360],
                        scale: [1, 1.5, 1],
                        backgroundColor: ["#d4af37", "#00000000", "#000000", "#000000", "#d4af37", "#d4af37", "#d4af37"],
                    }}
                    transition={{
                        duration: 12,
                        repeat: Infinity,
                        ease: "easeInOut",
                        // No delay to start immediately
                    }}
                >
                    {/* 
                        THE INNER LOGO 
                        - Rotates in reverse to counter-act the container rotation.
                        - "Folga": Angles are slightly mismatched (-85 vs 90) for wobble effect.
                    */}
                    <m.div
                        className="relative w-full h-full flex items-center justify-center"
                        animate={{
                            rotate: [0, -85, -180, -275, -360],
                        }}
                        transition={{
                            duration: 12,
                            repeat: Infinity,
                            ease: "easeInOut",
                        }}
                    >
                        <Image
                            src="/midas_black.png"
                            alt="Midas Logo"
                            width={80}
                            height={80}
                            className="object-contain drop-shadow-[0_0_10px_rgba(234,179,8,0.8)]"
                        />
                    </m.div>
                </m.div>
            </div>

            {/* ─── DOMINANCE FIELD (Subtle expansion waves) ─── */}
            <m.div
                className="absolute w-20 h-20 border border-midas-yellow-500/30 rounded-full opacity-0 pointer-events-none"
                animate={{
                    scale: [1, 3],
                    opacity: [0.5, 0],
                    borderWidth: ["1px", "0px"]
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeOut",
                    delay: 1.5
                }}
            />
        </div>
    );
};
